import { call, put, takeLatest } from 'redux-saga/effects';
import types from '../actions/form.actions';
import { storeData, storeFormData, changeStatus, changeStatusCatalogo } from '../actions/form.actions';
import api from "../api/api";

export function* getData() {
    yield takeLatest(types.GET_DATA, takeLatestData);
}

function* takeLatestData({ payload }) {

    let response = null
    switch (payload.formId) {
        case 'Casos':
            response = yield call(api.get, `/v1/casos/${payload.pagina}/pagina`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Victimas':
            response = yield call(api.get, `/v1/victimas/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Sospechosos':
            response = yield call(api.get, `/v1/sospechosos/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Armas':
            response = yield call(api.get, `/v1/armas/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'EstadoCaso':
            response = yield call(api.get, `/v1/estado-caso/${payload.idCaso}/caso`);
            yield put(storeFormData(payload.formId, response.data));
            break;

        case 'Roles':
            response = yield call(api.get, `/v1/roles`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Catalogos':
            response = yield call(api.get, `/v1/catalogos`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Usuarios':
            response = yield call(api.get, `/v1/usuarios/all`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'UsuariosUnregpol':
            response = yield call(api.get, `/v1/usuarios/unregpol`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Allanamientos':
            response = yield call(api.get, `/v1/allanamientos/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'InformacionInteres':
            response = yield call(api.get, `/v1/informacion-interes/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Entrevistas':
            response = yield call(api.get, `/v1/entrevistados/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Camaras':
            response = yield call(api.get, `/v1/camaras/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Celdas':
            response = yield call(api.get, `/v1/celdas/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'InformeContacto':
            response = yield call(api.get, `/v1/informe-contacto/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VigilanciaSeguimiento':
            response = yield call(api.get, `/v1/vigilancia-seguimiento/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Pericia':
            response = yield call(api.get, `/v1/tecnicas/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Delegacion':
            response = yield call(api.get, `/v1/delegacion/${payload.idCaso}/caso`);
            yield put(storeFormData(payload.formId, response.data));
            break;

        case 'Memo':
            response = yield call(api.get, `/v1/memos/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Versiones':
            response = yield call(api.get, `/v1/versiones/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Notificacion':
            response = yield call(api.get, `/v1/notificaciones/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'EventoRelacionado':
            response = yield call(api.get, `/v1/relacion-eventos/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Detenciones':
            response = yield call(api.get, `/v1/detenciones/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Incautaciones':
            response = yield call(api.get, `/v1/incautaciones/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'AllanamientosInvestigacion':
            response = yield call(api.get, `/v1/acto-urgente/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Boletas':
            response = yield call(api.get, `/v1/boletas/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaAllanamiento':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/allanamiento`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoAllanamiento':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/allanamiento`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ImagenesAllanamiento':
            response = yield call(api.get, `/v1/imagenes/${payload.idCaso}`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaInformacionInteres':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/informacion-interes`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoInformacionInteres':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/informacion-interes`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'TelefonoInformacionInteres':
            response = yield call(api.get, `/v1/telefonos-interes/${payload.idCaso}/informacion-interes`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'DomicilioInformacionInteres':
            response = yield call(api.get, `/v1/domicilios-interes/${payload.idCaso}/informacion-interes`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'AliasInformacionInteres':
            response = yield call(api.get, `/v1/alias-interes/${payload.idCaso}/informacion-interes`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaEntrevista':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/entrevista`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoEntrevista':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/entrevista`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ArchivosPericia':
        case 'ImagenesPericia':
            response = yield call(api.get, `/v1/imagenes/${payload.idCaso}/pericia-tecnica`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaInformeContacto':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/informe-contacto`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoInformeContacto':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/informe-contacto`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ImagenesInformeContacto':
            response = yield call(api.get, `/v1/imagenes/${payload.idCaso}/informe-contacto`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaVigilanciaSeguimiento':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/vigilancia`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoVigilanciaSeguimiento':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/vigilancia`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaVersiones':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/versiones`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoVersiones':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/versiones`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ImagenesReconocimientoLugar':
            response = yield call(api.get, `/v1/imagenes/${payload.idCaso}/reconocimiento-lugar`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaDetenciones':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/detencion`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoIncautacion':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/incautacion`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ArmasIncautacion':
            response = yield call(api.get, `/v1/armas-interes/${payload.idCaso}/incautacion`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'CelularIncautacion':
            response = yield call(api.get, `/v1/celulares-interes/${payload.idCaso}/incautacion`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'DocumentoIncautacion':
            response = yield call(api.get, `/v1/documento-interes/${payload.idCaso}/incautacion`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ObjetoIncautacion':
            response = yield call(api.get, `/v1/objetos-interes/${payload.idCaso}/incautacion`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PersonaAllanamientosInvestigacion':
            response = yield call(api.get, `/v1/personas-interes/${payload.idCaso}/acto-urgente`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'VehiculoAllanamientosInvestigacion':
            response = yield call(api.get, `/v1/vehiculos-interes/${payload.idCaso}/acto-urgente`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ArmasAllanamientosInvestigacion':
            response = yield call(api.get, `/v1/armas-interes/${payload.idCaso}/acto-urgente`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'CelularAllanamientosInvestigacion':
            response = yield call(api.get, `/v1/celulares-interes/${payload.idCaso}/acto-urgente`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'DocumentoAllanamientosInvestigacion':
            response = yield call(api.get, `/v1/documento-interes/${payload.idCaso}/acto-urgente`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ObjetoAllanamientosInvestigacion':
            response = yield call(api.get, `/v1/objetos-interes/${payload.idCaso}/allanamiento`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Eventos':
            response = yield call(api.get, `/v1/eventos/${payload.pagina}/pagina`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Indicio':
            response = yield call(api.get, `/v1/indicios/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Triaje':
            response = yield call(api.get, `/v1/triaje/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'ArmasBalistica':
            response = yield call(api.get, `/v1/armasBalistica/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'FallecidoVictima':
            response = yield call(api.get, `/v1/fallecidos/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'DetenidoBalistica':
            response = yield call(api.get, `/v1/detenidos/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'PeritoBalistica':
            response = yield call(api.get, `/v1/peritos/${payload.idCaso}/caso`);
            yield put(storeData(payload.formId, response.data.result));
            break;

        case 'Referencias':
            response = yield call(api.get, `/v1/referencias/${payload.pagina}/pagina`);
            yield put(storeData(payload.formId, response.data.result));
            break;
    }
}

export function* getMatrizControl() {
    yield takeLatest(types.GET_MATRIZ_CONTROL, takeLatestMatrizControl);
}

function* takeLatestMatrizControl({ payload }) {
    const response = yield call(api.post, `/v1/casos/${payload.pagina}/filtros`, { ...payload.body });
    yield put(storeData(payload.formId, response.data.result));
}

export function* saveData() {
    yield takeLatest(types.SAVE_DATA, takeLatestSaveData);
}

function* takeLatestSaveData({ payload }) {

    const action = 'SAVE';
    let response = null
    let url = '';

    switch (payload.formId) {
        case 'Caso':
            url = (payload.values.id == '') ? '/v1/casos' : `/v1/casos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });

            if ((payload.values.id == '') && (response.status == 200)) {

                const formValues = {
                    caso: response.data.result.id,
                    id: '',
                    estadoCaso: '',
                    etapa: '',
                    detalleEtapa: '',
                    observacion: ''
                }

                yield call(api.post, '/v1/estado-caso', { ...formValues });
            }

            break;

        case 'Victimas':
            url = (payload.values.id == '') ? '/v1/victimas' : `/v1/victimas/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Sospechosos':
            url = (payload.values.id == '') ? '/v1/sospechosos' : `/v1/sospechosos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Armas':
            url = (payload.values.id == '') ? '/v1/armas' : `/v1/armas/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'EstadoCaso':
            url = (payload.values.id == '') ? '/v1/estado-caso' : `/v1/estado-caso/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Roles':
            url = (payload.values.id == '') ? '/v1/roles' : `/v1/roles/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'FuentesAbiertasAdm':
            url = (payload.values.id == '') ? '/v1/fuentes-abiertas/fuente' : `/v1/fuentes-abiertas/fuente/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'FuentesAbiertasAdmMetodo':
            url = (payload.values.id == '') ? '/v1/fuentes-abiertas/metodo' : `/v1/fuentes-abiertas/metodo/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Catalogos':
            url = (payload.values.id == '') ? `/v1/catalogos/${payload.values.nombreBase}` : `/v1/atributos/${payload.values.id}/tabla/${payload.values.nombreBase}`;
            const body = {
                id: payload.values.id,
                descripcion: payload.values.descripcion
            }
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...body });
            break;

        case 'Usuarios':
        case 'UsuariosUnregpol':
            url = (payload.values.id == '') ? '/v1/usuarios' : `/v1/usuarios/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'BusquedaAlias':
            url = (payload.values.id == '') ? '/v1/alias-interes' : `/v1/alias-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Allanamientos':
            url = (payload.values.id == '') ? '/v1/allanamientos' : `/v1/allanamientos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'InformacionInteres':
            url = (payload.values.id == '') ? '/v1/informacion-interes' : `/v1/informacion-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Entrevistas':
            url = (payload.values.id == '') ? '/v1/entrevistados' : `/v1/entrevistados/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Camaras':
            url = (payload.values.id == '') ? '/v1/camaras' : `/v1/camaras/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Celdas':
            url = (payload.values.id == '') ? '/v1/celdas' : `/v1/celdas/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'InformeContacto':
            url = (payload.values.id == '') ? '/v1/informe-contacto' : `/v1/informe-contacto/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'VigilanciaSeguimiento':
            url = (payload.values.id == '') ? '/v1/vigilancia-seguimiento' : `/v1/vigilancia-seguimiento/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Pericia':
            url = (payload.values.id == '') ? '/v1/tecnicas' : `/v1/tecnicas/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Delegacion':
            url = (payload.values.id == '') ? '/v1/delegacion' : `/v1/delegacion/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Memo':
            url = (payload.values.id == '') ? '/v1/memos' : `/v1/memos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Versiones':
            url = (payload.values.id == '') ? '/v1/versiones' : `/v1/versiones/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Notificacion':
            url = (payload.values.id == '') ? '/v1/notificaciones' : `/v1/notificaciones/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'EventoRelacionado':
            url = (payload.values.id == '') ? '/v1/relacion-eventos' : `/v1/relacion-eventos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Detenciones':
            url = (payload.values.id == '') ? '/v1/detenciones' : `/v1/detenciones/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Incautaciones':
            url = (payload.values.id == '') ? '/v1/incautaciones' : `/v1/incautaciones/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'AllanamientosInvestigacion':
            url = (payload.values.id == '') ? '/v1/acto-urgente' : `/v1/acto-urgente/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Boletas':
            url = (payload.values.id == '') ? '/v1/boletas' : `/v1/boletas/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'PersonaAllanamiento':
        case 'PersonaInformacionInteres':
        case 'PersonaEntrevista':
        case 'PersonaInformeContacto':
        case 'PersonaVigilanciaSeguimiento':
        case 'PersonaVersiones':
        case 'PersonaDetenciones':
        case 'PersonaAllanamientosInvestigacion':
            url = (payload.values.id == '') ? '/v1/personas-interes' : `/v1/personas-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'VehiculoAllanamiento':
        case 'VehiculoInformacionInteres':
        case 'VehiculoEntrevista':
        case 'VehiculoInformeContacto':
        case 'VehiculoVigilanciaSeguimiento':
        case 'VehiculoVersiones':
        case 'VehiculoIncautacion':
        case 'VehiculoAllanamientosInvestigacion':
            url = (payload.values.id == '') ? '/v1/vehiculos-interes' : `/v1/vehiculos-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'IndiciosAllanamiento':
            response = yield call(api.put, `/v1/allanamiento-indicios/${payload.values.allanamiento}`, { ...payload.values });
            break;

        case 'TelefonoInformacionInteres':
            url = (payload.values.id == '') ? '/v1/telefonos-interes' : `/v1/telefonos-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'DomicilioInformacionInteres':
            url = (payload.values.id == '') ? '/v1/domicilios-interes' : `/v1/domicilios-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'AliasInformacionInteres':
            url = (payload.values.id == '') ? '/v1/alias-interes' : `/v1/alias-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'ArmasIncautacion':
        case 'ArmasAllanamientosInvestigacion':
            url = (payload.values.id == '') ? '/v1/armas-interes' : `/v1/armas-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'CelularIncautacion':
        case 'CelularAllanamientosInvestigacion':
            url = (payload.values.id == '') ? '/v1/celulares-interes' : `/v1/celulares-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'DocumentoIncautacion':
        case 'DocumentoAllanamientosInvestigacion':
            url = (payload.values.id == '') ? '/v1/documento-interes' : `/v1/documento-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'ObjetoIncautacion':
        case 'ObjetoAllanamientosInvestigacion':
            url = (payload.values.id == '') ? '/v1/objetos-interes' : `/v1/objetos-interes/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Evento':
            url = (payload.values.id == '') ? '/v1/evento' : `/v1/evento/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Indicio':
            url = (payload.values.id == '') ? '/v1/indicios' : `/v1/indicios/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'Triaje':
            url = (payload.values.id == '') ? '/v1/triaje' : `/v1/triaje/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'ArmasBalistica':
            url = (payload.values.id == '') ? '/v1/armasBalistica' : `/v1/armasBalistica/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'FallecidoVictima':
            url = (payload.values.id == '') ? '/v1/fallecidos' : `/v1/fallecidos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'DetenidoBalistica':
            url = (payload.values.id == '') ? '/v1/detenidos' : `/v1/detenidos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        case 'PeritoBalistica':
            url = (payload.values.id == '') ? '/v1/peritos' : `/v1/peritos/${payload.values.id}`;
            response = yield call((payload.values.id == '') ? api.post : api.put, url, { ...payload.values });
            break;

        default:
            break;
    }

    if (payload.formId !== 'Catalogos') {
        yield put(changeStatus(response.data, payload.formId, action));
    } else {
        const message = 'El registro ha sido guardado con éxito.'
        yield put(changeStatusCatalogo(message, payload.formId, action))
    }
}

export function* getDataById() {
    yield takeLatest(types.GET_DATA_BY_ID, takeLatestDataById);
}

function* takeLatestDataById({ payload }) {

    let response = null
    switch (payload.formId) {
        case 'Caso':
            response = yield call(api.get, `/v1/casos/${payload.id}`);
            yield put(storeFormData(payload.formId, response.data));
            break;

        case 'MatrizControl':
            response = yield call(api.get, `/v1/matriz/${payload.id}/caso`);
            yield put(storeFormData(payload.formId, response.data));
            break;

        case 'Evento':
            response = yield call(api.get, `/v1/eventos/${payload.id}`);
            yield put(storeFormData(payload.formId, response.data));
            break;
    }
}

export function* getDataByNumeroCaso() {
    yield takeLatest(types.GET_DATA_BY_NUMERO_CASO, takeLatestDataByNumeroCaso);
}

function* takeLatestDataByNumeroCaso({ payload }) {
    const response = yield call(api.get, `/v1/casos/${payload.numeroCaso}/numero`);

    switch (payload.formId) {
        case 'Caso':
            yield put(storeFormData(payload.formId, response.data));
            break;

        case 'MatrizControl':
            yield put(storeData(payload.formId, [response.data.result]));
            break;

        case 'Actividades':
            yield put(storeFormData(payload.formId, response.data));
            break;

        case 'EventoRelacionadoCaso':
            yield put(storeFormData(payload.formId, response.data));
            break;

        default:
            break;
    }
}

export function* getDataByNumeroEvento() {
    yield takeLatest(types.GET_DATA_BY_NUMERO_EVENTO, takeLatestDataByNumeroEvento);
}

function* takeLatestDataByNumeroEvento({ payload }) {
    const response = yield call(api.post, `/v1/eventos/search`, { text: payload.numeroCaso });

    switch (payload.formId) {
        case 'Evento':
            yield put(storeFormData(payload.formId, response.data));
            //yield put(storeData(payload.formId, response.data.result));
            break;

        default:
            break;
    }
}

export function* deleteData() {
    yield takeLatest(types.DELETE_DATA, takeLatestDeleteData);
}

function* takeLatestDeleteData({ payload }) {
    const action = 'DELETE';

    let url = '';
    switch (payload.formId) {

        case 'Victimas':
            url = `/v1/victimas/${payload.id}`;
            break;

        case 'Sospechosos':
            url = `/v1/sospechosos/${payload.id}`;
            break;

        case 'Armas':
            url = `/v1/armas/${payload.id}`;
            break;

        case 'Roles':
            url = `/v1/roles/${payload.id}`;
            break;

        case 'FuentesAbiertasAdm':
            url = `/v1/fuentes-abiertas/fuente/${payload.id}`;
            break;

        case 'FuentesAbiertasAdmMetodo':
            url = `/v1/fuentes-abiertas/metodo/${payload.id}`;
            break;

        case 'Catalogos':
            url = `/v1/atributos/${payload.id}/tabla/${payload.nombreBase}`;
            break;

        case 'Usuarios':
        case 'UsuariosUnregpol':
            url = `/v1/usuarios/${payload.id}`;
            break;

        case 'BusquedaAlias':
            url = `/v1/alias-interes/${payload.id}`;
            break;

        case 'Allanamientos':
            url = `/v1/allanamientos/${payload.id}`;
            break;

        case 'InformacionInteres':
            url = `/v1/informacion-interes/${payload.id}`;
            break;

        case 'Entrevistas':
            url = `/v1/entrevistados/${payload.id}`;
            break;

        case 'Camaras':
            url = `/v1/camaras/${payload.id}`;
            break;

        case 'Celdas':
            url = `/v1/celdas/${payload.id}`;
            break;

        case 'InformeContacto':
            url = `/v1/informe-contacto/${payload.id}`;
            break;

        case 'VigilanciaSeguimiento':
            url = `/v1/vigilancia-seguimiento/${payload.id}`;
            break;

        case 'Pericia':
            url = `/v1/tecnicas/${payload.id}`;
            break;

        case 'Delegacion':
            url = `/v1/delegacion/${payload.id}`;
            break;

        case 'Memo':
            url = `/v1/memos/${payload.id}`;
            break;

        case 'Versiones':
            url = `/v1/versiones/${payload.id}`;
            break;

        case 'Notificacion':
            url = `/v1/notificaciones/${payload.id}`;
            break;

        case 'EventoRelacionado':
            url = `/v1/relacion-eventos/${payload.id}`;
            break;

        case 'Detenciones':
            url = `/v1/detenciones/${payload.id}`;
            break;

        case 'Incautaciones':
            url = `/v1/incautaciones/${payload.id}`;
            break;

        case 'AllanamientosInvestigacion':
            url = `/v1/acto-urgente/${payload.id}`;
            break;

        case 'Boletas':
            url = `/v1/boletas/${payload.id}`;
            break;

        case 'PersonaAllanamiento':
        case 'PersonaInformacionInteres':
        case 'PersonaEntrevista':
        case 'PersonaInformeContacto':
        case 'PersonaVigilanciaSeguimiento':
        case 'PersonaVersiones':
        case 'PersonaDetenciones':
        case 'PersonaAllanamientosInvestigacion':
            url = `/v1/personas-interes/${payload.id}`;
            break;

        case 'VehiculoAllanamiento':
        case 'VehiculoInformacionInteres':
        case 'VehiculoEntrevista':
        case 'VehiculoInformeContacto':
        case 'VehiculoVigilanciaSeguimiento':
        case 'VehiculoVersiones':
        case 'VehiculoIncautacion':
        case 'VehiculoAllanamientosInvestigacion':
            url = `/v1/vehiculos-interes/${payload.id}`;
            break;

        case 'ImagenesAllanamiento':
        case 'ImagenesPericia':
        case 'ImagenesInformeContacto':
        case 'ImagenesReconocimientoLugar':
        case 'ArchivosPericia':
            url = `/v1/imagenes/${payload.id}`;
            break;

        case 'TelefonoInformacionInteres':
            url = `/v1/telefonos-interes/${payload.id}`;
            break;

        case 'DomicilioInformacionInteres':
            url = `/v1/domicilios-interes/${payload.id}`;
            break;

        case 'AliasInformacionInteres':
            url = `/v1/alias-interes/${payload.id}`;
            break;

        case 'ArmasIncautacion':
        case 'ArmasAllanamientosInvestigacion':
            url = `/v1/armas-interes/${payload.id}`;
            break;

        case 'CelularIncautacion':
        case 'CelularAllanamientosInvestigacion':
            url = `/v1/celulares-interes/${payload.id}`;
            break;

        case 'DocumentoIncautacion':
        case 'DocumentoAllanamientosInvestigacion':
            url = `/v1/documento-interes/${payload.id}`;
            break;

        case 'ObjetoIncautacion':
        case 'ObjetoAllanamientosInvestigacion':
            url = `/v1/objetos-interes/${payload.id}`;
            break;

        case 'Indicio':
            url = `/v1/indicios/${payload.id}`;
            break;

        case 'Triaje':
            url = `/v1/triaje/${payload.id}`;
            break;

        case 'ArmasBalistica':
            url = `/v1/armasBalistica/${payload.id}`;
            break;

        case 'FallecidoVictima':
            url = `/v1/fallecidos/${payload.id}`;
            break;

        case 'DetenidoBalistica':
            url = `/v1/detenidos/${payload.id}`;
            break;

        case 'PeritoBalistica':
            url = `/v1/peritos/${payload.id}`;
            break;

        case 'Evento':
            url = `/v1/evento/${payload.id}`;
            break;

        case 'Referencias':
            url = `/v1/referencias/${payload.id}`;
            break;

        default:
            break;
    }

    let { data } = yield call(api.delete, url);

    if (payload.formId !== 'Catalogos') {
        yield put(changeStatus(data, payload.formId, action));
    } else {
        const message = 'El registro ha sido eliminado con éxito.'
        yield put(changeStatusCatalogo(message, payload.formId, action))
    }
}